import React from 'react';

export const Alert = ({ children, variant = 'default' }) => (
  <div className={`p-4 rounded ${variant === 'destructive' ? 'bg-red-100 text-red-700' : 'bg-blue-100 text-blue-700'}`}>
    {children}
  </div>
);

export const AlertDescription = ({ children }) => (
  <p>{children}</p>
);
